const config = {
    GOOGLE_AUTH_CLIENT_ID: process.env.REACT_APP_GAUTH_KEY,
    API_ENDPOINT: 'https://sales-app.bricknbolt.com',
    GOOGLE_MAPS_KEY: process.env.REACT_APP_MAPS_KEY,
    USE_CUSTOM_API_ENDPOINT: process.env.REACT_APP_USE_CUSTOM_API_ENDPOINT || true,
}

export default config;
